module.exports = __webpack_public_path__ + "static/media/maintenance.b86dfe75.png";